"use client" // This directive is specific to Next.js App Router; it will be ignored in a standard React setup.

import React, { useState, useEffect, useCallback } from "react"
import {
  Button,
  TextField,
  Box, // Using Box instead of Tabs/Tab for custom grid layout
  InputAdornment,
  Checkbox,
  FormControlLabel,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  Menu,
  Switch,
  Typography,
  TableContainer, // For table structure
  Table, // For table structure
  TableHead, // For table header
  TableBody, // For table body
  TableRow, // For table rows
  TableCell, // For table cells
  Paper, // For table container styling
  Fab, // For Floating Action Button
  Divider, // For dropdown menu separators
  Tooltip
} from "@mui/material"
import {
  ArrowUpward as ArrowUpDownIcon, // Using ArrowUpward as a placeholder for ArrowUpDown
  PhoneOutlined as PhoneOutlinedIcon, // Changed to outlined icon
  MailOutlined as MailOutlinedIcon,   // Changed to outlined icon
  Search as SearchIcon,
  Close as XIcon,
  People as UsersIcon,
  AccessTime as ClockIcon,
  CheckCircleOutline as UserCheckIcon, // Changed from PersonCheck to CheckCircleOutline
  DeleteOutline as DeleteOutlineIcon, // Changed to outlined icon
  KeyboardArrowDown as ChevronDownIcon,
  Add as PlusIcon,
  PersonAdd as UserPlusIcon,
  BookmarkBorderOutlined as BookmarkBorderOutlinedIcon, // Changed to outlined icon
  Check as CheckIcon, // Imported CheckIcon for selected dropdown items
} from "@mui/icons-material"
import BookmarkIcon from '@mui/icons-material/Bookmark';
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Link,
  useNavigate
   
} from "react-router-dom";
import LoaderWithLinearProgress from "../../app/components/LoaderWithLinearProgress";
// Removed 'next/link' and 'next/navigation' as per request for standard React/ReactDOM
// import Link from "next/link"
// import { useRouter }s from "next/navigation"

// Define a type for a member, including their status
interface Member {
  id: number
  name: string
  company: string
  type: string
  location: string
  email: string
  phone: string
  exploring: { text: string }[]
  offering: { text: string }[]
  seeking: { text: string }[]
  isFavorite: boolean
  avatar: string
  status: "member" | "pending" | "contact"
  requestDate?: string
  connectionDate?: string
}

// Consolidated initial data for all members
const allInitialMembers: Member[] = [
  {
    id: 1,
    name: "Sarah Johnson",
    company: "Johnson Legal Group",
    type: "Attorney",
    location: "Scottsdale, AZ",
    email: "sarah.johnson@email.com",
    phone: "(123)-456-7890",
    exploring: [{ text: "Blockchain Lending" }, { text: "Commercial Real Estate" }],
    offering: [{ text: "Broker Services" }, { text: "Appraisals and Valuations" }],
    seeking: [{ text: "Buyers" }, { text: "Commercial Real Estate" }],
    isFavorite: false,
    avatar: "",
    status: "member",
  },
  {
    id: 2,
    name: "Michael Chen",
    company: "Chen Realty Partners",
    type: "Broker",
    location: "Scottsdale, AZ",
    email: "michael.chen@email.com",
    phone: "(123)-456-7890",
    exploring: [{ text: "Climate Change" }],
    offering: [{ text: "Real Estate Agent Services" }],
    seeking: [{ text: "Sellers" }],
    isFavorite: true,
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    status: "member",
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    company: "Rodriguez Appraisal Services",
    type: "Appraiser",
    location: "Scottsdale, AZ",
    email: "emily.rodriguez@email.com",
    phone: "(123)-456-7890",
    exploring: [{ text: "Co-Living Spaces" }],
    offering: [{ text: "Property Appraisals" }],
    seeking: [{ text: "Property Listings" }],
    isFavorite: false,
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    status: "member",
  },
  {
    id: 4,
    name: "David Thompson",
    company: "Thompson Inspection Co.",
    type: "Inspector",
    location: "Scottsdale, AZ",
    email: "david.thompson@email.com",
    phone: "(123)-456-7890",
    exploring: [],
    offering: [],
    seeking: [],
    isFavorite: false,
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    status: "member",
  },
  {
    id: 5,
    name: "Lisa Wang",
    company: "First Capital Lending",
    type: "Lender",
    location: "Scottsdale, AZ",
    email: "lisa.wang@email.com",
    phone: "(123)-456-7890",
    avatar: "",
    exploring: [],
    offering: [],
    seeking: [],
    isFavorite: false,
    status: "member",
  },
  {
    id: 6,
    name: "Robert Martinez",
    company: "Secure Title Insurance",
    type: "Title Insurance",
    location: "Scottsdale, AZ",
    email: "robert.martinez@email.com",
    phone: "(123)-456-7890",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    exploring: [],
    offering: [],
    seeking: [],
    isFavorite: false,
    status: "member",
  },
  {
    id: 7,
    name: "Jennifer Lee",
    company: "Lee Escrow Services",
    type: "Escrow Agent",
    location: "Scottsdale, AZ",
    email: "jennifer.lee@email.com",
    phone: "(123)-456-7890",
    avatar: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face",
    exploring: [],
    offering: [],
    seeking: [],
    isFavorite: false,
    status: "member",
  },
  {
    id: 8,
    name: "Amanda Foster",
    company: "Foster Notary Services",
    type: "Notary Public",
    location: "Scottsdale, AZ",
    email: "amanda.foster@email.com",
    phone: "(123)-456-7890",
    avatar: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face",
    exploring: [],
    offering: [],
    seeking: [],
    isFavorite: false,
    status: "member",
  },
  {
    id: 9,
    name: "James Wilson",
    company: "Wilson Flood Inspection",
    type: "Flood Inspector",
    location: "Scottsdale, AZ",
    email: "james.wilson@email.com",
    phone: "(123)-456-7890",
    avatar: "",
    requestDate: "2024-01-15",
    exploring: [],
    offering: [],
    seeking: [],
    isFavorite: false,
    status: "pending",
  },
  {
    id: 10,
    name: "Patricia Brown",
    company: "Brown & Associates",
    type: "Attorney",
    location: "Scottsdale, AZ",
    email: "patricia.brown@email.com",
    phone: "(123)-456-7890",
    avatar: "",
    requestDate: "2024-01-12",
    exploring: [],
    offering: [],
    seeking: [],
    isFavorite: false,
    status: "pending",
  },
  {
    id: 11,
    name: "Thomas Garcia",
    company: "Garcia Brokerage",
    type: "Broker",
    location: "Scottsdale, AZ",
    email: "thomas.garcia@email.com",
    phone: "(123)-456-7890",
    avatar: "",
    connectionDate: "2023-11-20",
    exploring: [],
    offering: [],
    seeking: [],
    isFavorite: false,
    status: "contact",
  },
  {
    id: 12,
    name: "Rebecca Taylor",
    company: "Taylor Appraisals",
    type: "Appraiser",
    location: "Scottsdale, AZ",
    email: "rebecca.taylor@email.com",
    phone: "(123)-456-7890",
    avatar: "",
    connectionDate: "2023-11-20",
    exploring: [],
    offering: [],
    seeking: [],
    isFavorite: false,
    status: "contact",
  },
]

const cities = [
  "Scottsdale, AZ",
  "New York, NY",
  "Los Angeles, CA",
  "Chicago, IL",
  "Houston, TX",
  "Phoenix, AZ",
  "Philadelphia, PA",
  "San Antonio, TX",
  "San Diego, CA",
  "Dallas, TX",
]

const memberTypes = [
  "General Member",
  "Attorney",
  "Appraiser",
  "Broker",
  "Title Insurance",
  "Flood Inspector",
  "Inspector",
  "Escrow Agent",
  "Lender",
  "Notary Public",
]

// Define filter options based on provided images
const filterOptions = {
  seeking: [
    "Affordable Housing",
    "Buyers",
    "Commercial Real Estate",
    "Developments Existing",
    "Developments New",
    "Energy Efficiency",
    "Environmental Hazards",
    "Flood Insurance for High Risk Areas",
    "Green Property",
    "Loans Commercial",
    "Loans Residential",
    "Mortgage Homes",
    "Mortgage Commercial",
    "Moving",
    "New Development",
    "Ownership",
    "Ownership Solutions",
    "Pre-Listing Needs",
    "Property Listings",
    "Rentals",
    "Sellers",
    "Senior Living Facilities",
    "Short-Term Rental",
  ],
  offering: [
    "Appraisals and Valuations",
    "Broker Services",
    "Co-Living Space Insurance",
    "Commercial Insurance",
    "Compliance with E-Signatures",
    "Cybersecurity",
    "Drone Inspections",
    "Escrow Management",
    "Escrow Services",
    "Escrow Services Digital",
    "Escrow Services International",
    "Financial Services",
    "Flood Insurance",
    "Flood Mitigation",
    "Flood Risk Assessment",
    "Green Building Insurance",
    "Home Auto Umbrella Insurance",
    "Home Insurance",
    "Inspection Services",
    "Lending Services",
    "Property Appraisals",
    "Property Inspections",
    "Real Estate Agent Services",
    "Real Estate Crowdfunding",
    "Real Estate Insurance",
    "Real Estate Investment Trusts (REITs)",
    "Real Estate Marketing",
    "Real Estate Photography and Virtual Tours",
    "Real Estate Tech Lending",
    "Real Estate Technology",
    "Real Estate Valuations",
    "Settlement Services",
    "Smart Home Inspections",
    "Title Insurance",
    "Virtual Closings and Remote Notarizations",
    "Virtual Reality",
  ],
  exploring: [
    "Blockchain Lending",
    "Blockchain Transactions",
    "Climate Change",
    "Co-Living Spaces",
    "Commercial Real Estate",
    "Compliance with E-Signatures",
    "Cybersecurity",
    "Development Laws",
    "Facility Regulations",
    "Insurance Compliance",
    "Legal Compliance",
    "Legal Frameworks",
    "Prop Tech Law",
    "Properties Laws Co-Living",
    "Properties Laws Commercial",
    "Properties Laws Residential",
    "Real Estate Compliance",
    "Real Estate Law",
    "Regulations",
    "Regulatory Changes",
    "Tech Integration of Escrow Services",
  ],
  favorites: ["Favorite Members"], // Placeholder for now
}

/**
 * Helper component for Material-UI Tabs to display content for each tab.
 * @param props - Props for the TabPanel.
 */
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>} {/* Reduced padding here for table */}
    </div>
  )
}

/**
 * Generates accessibility props for Material-UI Tabs.
 * @param index - The index of the tab.
 */
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

const textColor = "#0d2561";
const itextColor = "#707070";

/**
 * Main component for the My Network Page, demonstrating Material-UI usage.
 */
const MyNetworkPage: React.FC = () => {
  const [selectedLocation, setSelectedLocation] = useState<string>("all")
  const [selectedType, setSelectedType] = useState<string>("all")
  const [activeTab, setActiveTab] = useState(0) // Changed to number for MUI Tabs
  const [selectedMembers, setSelectedMembers] = useState<number[]>([])
  const [searchQuery, setSearchQuery] = useState("")

  // Master list of all members, whose 'status' will be updated
  const [allMembers, setAllMembers] = useState<Member[]>(allInitialMembers)

  // States for filter categories
  const [selectedExploring, setSelectedExploring] = useState<string[]>([])
  const [selectedOffering, setSelectedOffering] = useState<string[]>([])
  const [selectedSeeking, setSelectedSeeking] = useState<string[]>([])
  const [selectedFavorite, setSelectedFavorite] = useState<boolean>(false)

  const [isFabOpen, setIsFabOpen] = useState(false) // State for FAB menu

  // Separate states for each dropdown's anchor element
  const [seekingAnchorEl, setSeekingAnchorEl] = useState<null | HTMLElement>(null);
  const [offeringAnchorEl, setOfferingAnchorEl] = useState<null | HTMLElement>(null);
  const [exploringAnchorEl, setExploringAnchorEl] = useState<null | HTMLElement>(null);
  const [favoritesAnchorEl, setFavoritesAnchorEl] = useState<null | HTMLElement>(null);

  const [isFilterActive,setIsFilterActive] = useState(false);
  const [loading, setLoading] = useState(true);


  // Effect to load favorite status and pending requests from localStorage on component mount
  useEffect(() => {

    setAllMembers((prevAllMembers) => {
      let updatedMembers = [...prevAllMembers]

      // Load favorite status for all members
      updatedMembers = updatedMembers.map((member) => {
        const storedFavorite = localStorage.getItem(`member_favorite_${member.id}`)
        return { ...member, isFavorite: storedFavorite ? JSON.parse(storedFavorite) : member.isFavorite }
      })

      // Load pending connections from localStorage
      const pendingConnectId = localStorage.getItem("pending_connect_id")
      if (pendingConnectId) {
        const connectedMemberId = Number.parseInt(pendingConnectId, 10)
        const memberIndex = updatedMembers.findIndex((m) => m.id === connectedMemberId && m.status === "member")

        if (memberIndex !== -1) {
          // Update the member's status to 'pending'
          updatedMembers[memberIndex] = {
            ...updatedMembers[memberIndex],
            status: "pending",
            requestDate: new Date().toISOString().split("T")[0],
          }
          localStorage.removeItem("pending_connect_id") // Clear the flag after processing
        }
      }
      
      return updatedMembers
    })
    setLoading(false);
  }, []) // Run only once on mount


  const toggleSelectMember = useCallback((id: number) => {
    setSelectedMembers((prev) =>
      prev.includes(id) ? prev.filter((memberId) => memberId !== id) : [...prev, id]
    )
  }, []);

  const selectAll = useCallback(
    (membersList: Member[]) => {
      if (selectedMembers.length === membersList.length && membersList.length > 0) {
        setSelectedMembers([])
      } else {
        setSelectedMembers(membersList.map((member) => member.id))
      }
    },
    [selectedMembers],
  )

  const handleConnect = useCallback((member: Member) => {
    // This function will primarily be called from the members list
    setAllMembers((prevAllMembers) =>
      prevAllMembers.map((m) =>
        m.id === member.id ? { ...m, status: "pending", requestDate: new Date().toISOString().split("T")[0] } : m,
      ),
    )
    // In a real app, you might trigger a toast or a modal here for confirmation
    console.log(`Connection request sent to ${member.name}`)
  }, [])

  const handleDeleteMember = useCallback((memberId: number, section: string) => {
    setAllMembers((prevAllMembers) =>
      prevAllMembers.map((m) => {
        if (m.id === memberId) {
          if (section === "pending") {
            // If it's a bookmarked member, unbookmark them and revert to 'member' status
            if (m.isFavorite) {
              localStorage.setItem(`member_favorite_${memberId}`, JSON.stringify(false))
              return { ...m, isFavorite: false, status: "member", requestDate: undefined }
            }
            // For non-bookmarked, just revert to 'member' status
            return { ...m, status: "member", requestDate: undefined }
          } else if (section === "contacts") {
            // For contacts, revert to 'member' status
            localStorage.setItem(`member_favorite_${memberId}`, JSON.stringify(false)) // Also unbookmark if they were favorited
            return { ...m, isFavorite: false, status: "member", connectionDate: undefined }
          } else if (section === "members") {
            // If deleting directly from members, just remove favorite if it was set
            localStorage.removeItem(`member_favorite_${memberId}`)
            return { ...m, isFavorite: false } // No change in status, just favorite
          }
        }
        return m
      }),
    )
    console.log(`Member ${memberId} deleted from ${section}`)
  }, [])

  const handleBookmark = useCallback((memberId: number) => {
    setAllMembers((prevAllMembers) =>
      prevAllMembers.map((m) => {
        if (m.id === memberId) {
          const newFavoriteStatus = !m.isFavorite
          localStorage.setItem(`member_favorite_${memberId}`, JSON.stringify(newFavoriteStatus))
          return { ...m, isFavorite: newFavoriteStatus }
        }
        return m
      }),
    )
  }, [])

  // Generic handler for multi-select dropdowns
  const handleFilterChange = useCallback((
    category: string,
    value: string,
    setter: React.Dispatch<React.SetStateAction<string[]>>,
    currentSelection: string[],
  ) => {
    if (currentSelection.includes(value)) {
      setter(currentSelection.filter((item) => item !== value))
    } else {
      setter([...currentSelection, value])
    }
  }, []);

  const handleToggleFillter = () => {
    setIsFilterActive(true);
  };

  const clearAllFilters = useCallback(() => {
    setSelectedExploring([])
    setSelectedOffering([])
    setSelectedSeeking([])
    setSelectedFavorite(false)
    setSelectedLocation("all")
    setSelectedType("all")
    setSearchQuery("")
     setIsFilterActive(false);
  }, []);

  // Determine if any filter is active
  const isAnyFilterActive =
    selectedLocation !== "all" ||
    selectedType !== "all" ||
    searchQuery !== "" ||
    selectedExploring.length > 0 ||
    selectedOffering.length > 0 ||
    selectedSeeking.length > 0 ||
    selectedFavorite;


  const applyFilters = useCallback(
    (memberList: Member[]) => {
      return memberList.filter((member) => {
        const locationMatch = selectedLocation === "all" || member.location.includes(selectedLocation)
        const typeMatch = selectedType === "all" || member.type === selectedType
        const searchMatch =
          searchQuery === "" ||
          member.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          member.company.toLowerCase().includes(searchQuery.toLowerCase())

        const exploringMatch =
          selectedExploring.length === 0 ||
          selectedExploring.some((filter) => member.exploring?.some((e) => e.text === filter))
        const offeringMatch =
          selectedOffering.length === 0 ||
          selectedOffering.some((filter) => member.offering?.some((o) => o.text === filter))
        const seekingMatch =
          selectedSeeking.length === 0 ||
          selectedSeeking.some((filter) => member.seeking?.some((s) => s.text === filter))
        const favoriteMatch = !selectedFavorite || member.isFavorite === true

        return (
          locationMatch && typeMatch && searchMatch && exploringMatch && offeringMatch && seekingMatch && favoriteMatch
        )
      })
    },
    [
      selectedLocation,
      selectedType,
      searchQuery,
      selectedExploring,
      selectedOffering,
      selectedSeeking,
      selectedFavorite,
    ],
  )

  const members = applyFilters(allMembers.filter((m) => m.status === "member"))
  const pendingRequests = applyFilters(allMembers.filter((m) => m.status === "pending"))
  const myContacts = applyFilters(allMembers.filter((m) => m.status === "contact"))

  // Map activeTab number to string value for consistency with original logic
  const activeTabValue = ["members", "pending", "contacts"][activeTab];
  const navigate = useNavigate();
  const handleViewProfile = (memberId: number,membersection : string) => {
        navigate(`/member/${memberId}?section=${membersection}`);
    };

  const renderMemberRow = useCallback(
    (member: Member, section: "members" | "pending" | "contacts") => {
      // Destructure member properties for explicit access
      const { id, name, company, location, phone, requestDate, connectionDate, isFavorite, avatar } = member;

      return (
        <TableRow key={id} sx={{ borderBottom: '1px solid #e0e0e0', '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.04)' } /* border-b border-muted hover:bg-secondary/50 */ }}>
          <TableCell sx={{ py: '12px', px: '16px' /* py-3 px-4 */ }}>
            <Checkbox
              checked={selectedMembers.includes(id)}
              onChange={() => toggleSelectMember(id)}
              size="small"
              icon={
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    border: '1px solid #00194A', // dark blue border
                    borderRadius: '4px', // slightly rounded
                  }}
                />
              }
              checkedIcon={
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    border: '1px solid #00194A',
                    borderRadius: '4px',
                    backgroundColor: '#00194A',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CheckIcon sx={{ fontSize: 16, color: 'white' }} />
                </Box>
              }
            />
          </TableCell>
          <TableCell sx={{ py: '12px', px: '16px' /* py-3 px-4 */ }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: '12px' /* flex items-center space-x-3 */ }}>
              <Avatar sx={{ width: 40, height: 40, flexShrink: 0, borderRadius: '50%' /* h-10 w-10 shrink-0 rounded-full */ }}>
                <img src={avatar || "/placeholder.svg"} alt={name} style={{ borderRadius: '50%', width: '100%', height: '100%', objectFit: 'cover', display:avatar ? 'inline' : 'none' }} />
                {/* Fallback for avatar image */}
                {!avatar && (
                  <Typography variant="caption" sx={{ textTransform: 'uppercase', fontWeight: 'bold' }}>
                    {name.split(" ").map((n: string) => n[0]).join("")}
                  </Typography>
                )}
              </Avatar>
              <Box>
                {/* Using a standard <a> tag since Next.js Link is removed */}
                <Button
                  component="a"
                  onClick={() => handleViewProfile(member.id,section)}                 
                  variant="text"
                  sx={{
                    textTransform: "none",
                    fontWeight: 'bold', // font-medium
                    color: textColor, // text-primary
                    fontSize: '1rem', // text-base (implied by font-medium)
                    p: 0,
                    minWidth: 0,
                    justifyContent: 'flex-start',
                    '&:hover': {
                      color: 'primary.dark', // hover:text-primary/80
                      textDecoration: 'underline', // hover:underline
                      bgcolor: 'transparent'
                    },
                    cursor: 'pointer',
                  }}
                >
                  {name} {/* Using destructured 'name' */}
                </Button>
                <Typography variant="body2" sx={{ fontSize: '0.875rem', color: 'text.secondary' /* text-sm text-muted-foreground */ }}>
                  {company} {/* Using destructured 'company' */}
                </Typography>
              </Box>
            </Box>
          </TableCell>
          <TableCell sx={{ py: '12px', px: '16px', fontSize: '0.875rem' /* py-3 px-4 text-sm */ }}>
            <Typography variant="body2">{location}</Typography> {/* Using destructured 'location' */}
          </TableCell>
          <TableCell sx={{ py: '12px', px: '16px', fontSize: '0.875rem', whiteSpace: 'nowrap' /* py-3 px-4 text-sm whitespace-nowrap */ }}>
            <Typography variant="body2">{phone}</Typography> {/* Using destructured 'phone' */}
          </TableCell>
          {section === "pending" && (
            <TableCell sx={{ py: '12px', px: '16px', fontSize: '0.875rem', whiteSpace: 'nowrap' }}>
              <Typography variant="body2">
                {requestDate ? new Date(requestDate).toLocaleDateString() : "N/A"} {/* Using destructured 'requestDate' */}
              </Typography>
            </TableCell>
          )}
          {section === "contacts" && (
            <TableCell sx={{ py: '12px', px: '16px', fontSize: '0.875rem', whiteSpace: 'nowrap' }}>
              <Typography variant="body2">
                {connectionDate ? new Date(connectionDate).toLocaleDateString() : "N/A"} {/* Using destructured 'connectionDate' */}
              </Typography>
            </TableCell>
          )}
          <TableCell sx={{ py: '12px', px: '16px' /* py-3 px-4 */ }}>
            <Box sx={{ display: "flex", gap: '8px' /* flex space-x-2 */ }}>
              {/* Phone Icon Button */}
               <IconButton
                size="small" // h-8 w-8 p-0,
                sx={{
                  border: 'none', // Always a transparent border to prevent layout shift
                  backgroundColor: 'none', // Normal state: white background
                  borderRadius: '6px',
                  transition: 'background-color 0.3s, border-color 0.3s, color 0.3s', // Added border-color transition
                  '&:hover': {
                    backgroundColor: 'green', // Hover state: green background
                    borderColor: 'black', // Hover state: black border
                    '& .MuiSvgIcon-root': {
                        color: 'white', // Hover state: white icon
                        fill: 'currentColor', // Hover state: solid white icon
                    },
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '1rem',
                    
                  },
                  '&.Mui-disabled': {
                    pointerEvents: 'none',
                    opacity: 0.5,
                  }
                }}
                
                
              >
                <PhoneOutlinedIcon />
              </IconButton>

              {/* Mail Icon Button */}
               <IconButton
                size="small"
                sx={{
                  border: 'none', // Always a transparent border
                  backgroundColor: 'none', // Normal state: white background
                  borderRadius: '6px',
                  transition: 'background-color 0.3s, border-color 0.3s, color 0.3s',
                  '&:hover': {
                    backgroundColor: 'green', // Hover state: green background
                    borderColor: 'black', // Hover state: black border
                    '& .MuiSvgIcon-root': {
                        color: 'white',
                        fill: 'currentColor',
                    },
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '1rem',
                    
                  },
                  '&.Mui-disabled': {
                    pointerEvents: 'none',
                    opacity: 0.5,
                  }
                }}
               
              >
                <MailOutlinedIcon />
              </IconButton>

              {section === "members" && (
                <>
                  {/* Bookmark Icon Button */}
                  <IconButton
                    size="small"
                    onClick={() => handleBookmark(id)}
                    sx={{
                      border: '1px solid transparent', // Always a transparent border
                      backgroundColor: 'white', // Normal state: white background
                      borderRadius: '6px',
                      transition: 'background-color 0.3s, border-color 0.3s, color 0.3s',
                      '&:hover': {
                        backgroundColor: 'green', // Hover state: green background
                        borderColor: 'black', // Hover state: black border
                        '& .MuiSvgIcon-root': {
                            color: 'white',
                            fill: 'currentColor',
                        },
                      },
                      '& .MuiSvgIcon-root': {
                        fontSize: '1rem',
                        pointerEvents: 'none',
                        flexShrink: 0,
                        // Bookmark specific styling
                        color: 'black', // Normal/Active state: black outline
                        fill: isFavorite ? 'currentColor' : 'currentColor', // Active: solid black, Normal: transparent fill
                      },
                      '&.Mui-disabled': {
                        pointerEvents: 'none',
                        opacity: 0.5,
                      }
                    }}
                    
                  >
                    {isFavorite ? (
                      <BookmarkIcon /> // filled version
                    ) : (
                      <BookmarkBorderOutlinedIcon /> // outlined version
                    )}
                  </IconButton>
                  { /*<Button variant="outlined" size="small" onClick={() => handleConnect(member)} sx={{ textTransform: 'none', borderRadius: 1 }}>
                    Connect
                  </Button> */ }
                </>
              )}
              {(section === "pending" || section === "contacts") && (
                <IconButton
                  size="small"
                  onClick={() => handleDeleteMember(id, section)}
                  sx={{
                      border: '1px solid transparent', // Always a transparent border
                      backgroundColor: 'white', // Normal state: white background
                      borderRadius: '6px',
                      transition: 'background-color 0.3s, border-color 0.3s, color 0.3s',
                      '&:hover': {
                        backgroundColor: 'green', // Hover state: green background
                        borderColor: 'black', // Hover state: black border
                        '& .MuiSvgIcon-root': {
                            color: 'white',
                            fill: 'currentColor',
                        },
                      },
                      '& .MuiSvgIcon-root': {
                        fontSize: '1rem',
                        pointerEvents: 'none',
                        flexShrink: 0,
                        // Bookmark specific styling
                        color: 'black', // Normal/Active state: black outline
                        fill: isFavorite ? 'red' : 'red', // Active: solid black, Normal: transparent fill
                      },
                      '&.Mui-disabled': {
                        pointerEvents: 'none',
                        opacity: 0.5,
                      }
                    }}
                >
                  <DeleteOutlineIcon />
                </IconButton>
              )}
            </Box>
          </TableCell>
        </TableRow>
      );
    },
    [selectedMembers, toggleSelectMember, handleConnect, handleBookmark, handleDeleteMember],
  )
if (loading) return <LoaderWithLinearProgress />;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", backgroundColor: "#f0f2f5" }}>
      {/* Main Content Area */}
      <Box component="main" sx={{
        flexGrow: 1,
        p: 3,
        ml: 0, // No left margin from sidebar
        width: '100%' // Full width
      }}>
        {/* Horizontal Filter Bar */}
        { isFilterActive ? (
        <Paper elevation={1} sx={{
          p: 2,
          mb: 3,
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
          justifyContent: "space-between",
          borderRadius: 2,
        }}>
          
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
          

            {/* Seeking Dropdown */}
            <Button
              variant="outlined"
              endIcon={<ChevronDownIcon />}
              onClick={(e) => setSeekingAnchorEl(e.currentTarget)} // Use specific setter
              sx={{
                textTransform: 'none',
                borderRadius: 1,
                borderColor: '#b5bcc6', // Black border
                borderWidth:'1px',
                color: textColor, // Black text
                '&:hover': {
                  borderColor: 'white', // Maintain black border on hover
                  bgcolor: '#00838f', // Light grey background on hover
                  color:'#ffffff'
                }
              }}
            >
              Seeking
            </Button>
            <Menu
              anchorEl={seekingAnchorEl} // Use specific anchor state
              open={Boolean(seekingAnchorEl)}
              onClose={() => setSeekingAnchorEl(null)} // Use specific setter
              PaperProps={{ style: { maxHeight: 400, width: 200, borderRadius: 2, boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' } }}
            >
              <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>Select options</Typography>
              <Divider />
              {filterOptions.seeking.map((option) => (
                <MenuItem
                  key={option}
                  onClick={() => handleFilterChange("seeking", option, setSelectedSeeking, selectedSeeking)}
                  sx={{
                    // Apply background color if selected
                    bgcolor: selectedSeeking.includes(option) ? 'white' : 'inherit', // White for selected
                    color: 'black', // Black text for all items
                    '&:hover': {
                      bgcolor: '#00838f', // Light green on hover
                      color: 'white',
                      borderRadius:'4px',
                      marginLeft:'4px',
                      marginRight:'4px'

                    },
                    py: '8px', // Adjusted vertical padding for dropdown items
                    px: '16px', // Adjusted horizontal padding for dropdown items
                    fontSize: '0.875rem', // Adjusted font size for dropdown items (corresponds to body2)
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {selectedSeeking.includes(option) && <CheckIcon fontSize="small" sx={{ color: 'black', mr: 1 }} />}
                  <Typography
                    variant="inherit"
                    sx={{
                      flexGrow: 1,
                      fontSize: 'inherit',
                      whiteSpace: 'normal', // Ensures text wraps
                      wordBreak: 'break-word', // Breaks long words if they don't fit
                    }}
                  >
                    {option}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>

            {/* Offering Dropdown */}
            <Button
              variant="outlined"
              endIcon={<ChevronDownIcon />}
              onClick={(e) => setOfferingAnchorEl(e.currentTarget)} // Use specific setter
              sx={{
                textTransform: 'none',
                borderRadius: 1,
                borderColor: '#b5bcc6', // Black border
                borderWidth:'1px',
                color: textColor, // Black text
                '&:hover': {
                  borderColor: 'white', // Maintain black border on hover
                  bgcolor: '#00838f', // Light grey background on hover
                  color:'#ffffff'
                }
              }}
            >
              Offering
            </Button>
            <Menu
              anchorEl={offeringAnchorEl} // Use specific anchor state
              open={Boolean(offeringAnchorEl)}
              onClose={() => setOfferingAnchorEl(null)} // Use specific setter
              PaperProps={{ style: { maxHeight: 400,width:250,borderRadius: 2, boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' } }}
            >
              <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>Select options</Typography>
              <Divider />
              {filterOptions.offering.map((option) => (
                <MenuItem
                  key={option}
                  onClick={() => handleFilterChange("offering", option, setSelectedOffering, selectedOffering)}
                  sx={{
                    bgcolor: selectedOffering.includes(option) ? 'white' : 'inherit',
                    color: 'black',
                    '&:hover': {
                      bgcolor: '#00838f', // Light green on hover
                      color: 'white',
                      borderRadius:'4px',
                      marginLeft:'4px',
                      marginRight:'4px'
                    },
                    py: '8px',
                    px: '16px',
                    fontSize: '0.875rem',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {selectedOffering.includes(option) && <CheckIcon fontSize="small" sx={{ color: 'black', mr: 1 }} />}
                  <Typography
                    variant="inherit"
                    sx={{
                      flexGrow: 1,
                      fontSize: 'inherit',
                      whiteSpace: 'normal', // Ensures text wraps
                      wordBreak: 'break-word', // Breaks long words if they don't fit
                    }}
                  >
                    {option}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>

            {/* Exploring Dropdown */}
            <Button
              variant="outlined"
              endIcon={<ChevronDownIcon />}
              onClick={(e) => setExploringAnchorEl(e.currentTarget)} // Use specific setter
              sx={{
                textTransform: 'none',
                borderRadius: 1,
                borderColor: '#b5bcc6', // Black border
                borderWidth:'1px',
                color: textColor, // Black text
                '&:hover': {
                  borderColor: 'white', // Maintain black border on hover
                  bgcolor: '#00838f', // Light grey background on hover
                  color:'#ffffff'
                }
              }}
            >
              Exploring
            </Button>
            <Menu
              anchorEl={exploringAnchorEl} // Use specific anchor state
              open={Boolean(exploringAnchorEl)}
              onClose={() => setExploringAnchorEl(null)} // Use specific setter
              PaperProps={{ style: { maxHeight: 400, width: 200, borderRadius: 2, boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' } }}
            >
              <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>Select options</Typography>
              <Divider />
              {filterOptions.exploring.map((option) => (
                <MenuItem
                  key={option}
                  onClick={() => handleFilterChange("exploring", option, setSelectedExploring, selectedExploring)}
                  sx={{
                    bgcolor: selectedExploring.includes(option) ? 'white' : 'inherit',
                    color: 'black',
                    '&:hover': {
                      bgcolor: '#00838f', // Light green on hover
                      color: 'white',
                      borderRadius:'4px',
                      marginLeft:'4px',
                      marginRight:'4px'
                    },
                    py: '8px',
                    px: '16px',
                    fontSize: '0.875rem',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {selectedExploring.includes(option) && <CheckIcon fontSize="small" sx={{ color: 'black', mr: 1 }} />}
                  <Typography
                    variant="inherit"
                    sx={{
                      flexGrow: 1,
                      fontSize: 'inherit',
                      whiteSpace: 'normal', // Ensures text wraps
                      wordBreak: 'break-word', // Breaks long words if they don't fit
                    }}
                  >
                    {option}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>

            {/* Favorites Dropdown (now a simple checkbox in a menu) */}
            <Button
              variant="outlined"
              endIcon={<ChevronDownIcon />}
              onClick={(e) => setFavoritesAnchorEl(e.currentTarget)} // Use specific setter
              sx={{
                textTransform: 'none',
                borderRadius: 1,
                borderColor: '#b5bcc6', // Black border
                borderWidth:'1px',
                color: textColor, // Black text
                '&:hover': {
                  borderColor: 'white', // Maintain black border on hover
                  bgcolor: '#00838f', // Light grey background on hover
                  color:'#ffffff'
                }
              }}
            >
              Favorites
            </Button>
            <Menu
              anchorEl={favoritesAnchorEl} // Use specific anchor state
              open={Boolean(favoritesAnchorEl)}
              onClose={() => setFavoritesAnchorEl(null)} // Use specific setter
              PaperProps={{ style: { width: 200, borderRadius: 2, boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)' } }}
            >
              <Typography variant="subtitle2" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>Select options</Typography>
              <Divider />
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedFavorite(!selectedFavorite);
                }}
                sx={{
                  bgcolor: selectedFavorite ? 'white' : 'inherit',
                  color: 'black',
                  '&:hover': {
                    bgcolor: '#00838f', // Light green on hover
                    color: 'white',
                    borderRadius:'4px',
                    marginLeft:'4px',
                    marginRight:'4px'
                  },
                  py: '8px',
                  px: '16px',
                  fontSize: '0.875rem',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {selectedFavorite && <CheckIcon fontSize="small" sx={{ color: 'black', mr: 1 }} />}
                <Typography variant="inherit" sx={{ flexGrow: 1, fontSize: 'inherit' }}>Show only favorites</Typography>
              </MenuItem>
            </Menu>
          
          </Box>

        
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                variant="text"
                onClick={clearAllFilters}
                sx={{ color: 'text.secondary', textTransform: 'none' }}
                endIcon={<XIcon fontSize="small" />} // Add the XIcon as an endIcon
              >
              
              </Button>
            </Box>
        </Paper>
        ): (
          
          <Box
            sx={{
              color: "#707070",
              display: "flex",
              justifyContent: "flex-end",
              margin: "10px",
              height: "55px",
            }}><Button
                onClick={handleToggleFillter}
                sx={{
                  "&:hover": {
                    backgroundColor: "#F5F5F5",
                  },
                }}
              >
                <FilterListIcon
                  sx={{
                    color: "rgba(112, 112, 112, 1)",
                    "&:hover": {
                      color: "rgba(13, 37, 97, 1)",
                    },
                  }}
                />
              </Button></Box>)}
        <Paper elevation={1} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
          <Box sx={{ display: "flex", flexDirection: { xs: 'column', md: 'row' }, alignItems: { md: 'center' }, justifyContent: "space-between", mb: 3, gap: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', color: textColor }}>My Network</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: 'column', md: 'row' }, gap: 2, width: { xs: '100%', md: 'auto' } }}>
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search members..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ width: { xs: '100%', md: 240 }, borderRadius: 1 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: 'action.active' }} />
                    </InputAdornment>
                  ),
                  endAdornment: searchQuery && (
                    <InputAdornment position="end">
                      <IconButton onClick={() => setSearchQuery("")} size="small" edge="end">
                        <XIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Select
                value={selectedLocation}
                onChange={(e) => setSelectedLocation(e.target.value as string)}
                displayEmpty
                inputProps={{ "aria-label": "Select location" }}
                size="small"
                sx={{ width: { xs: '100%', md: 180 }, borderRadius: 1}}
              >
                <MenuItem value="all" sx={{
                    
                    color: 'black', // Black text for all items
                    bgcolor: selectedLocation === "all" ? 'white' : 'inherit',
                    '&:hover': {
                      bgcolor: '#00838f', // Light green on hover
                      color: 'white',
                      borderRadius:'4px',
                      marginLeft:'4px',
                      marginRight:'4px'

                    },
                    py: '8px', // Adjusted vertical padding for dropdown items
                    px: '16px', // Adjusted horizontal padding for dropdown items
                    fontSize: '0.875rem', // Adjusted font size for dropdown items (corresponds to body2)
                    display: 'flex',
                    alignItems: 'center',
                  }}>All Locations</MenuItem>
                {cities.map((city) => (
                  <MenuItem key={city} value={city}  sx={{
                    
                    color: 'black', // Black text for all items
                    '&:hover': {
                      bgcolor: '#00838f', // Light green on hover
                      color: 'white',
                      borderRadius:'4px',
                      marginLeft:'4px',
                      marginRight:'4px'

                    },
                    py: '8px', // Adjusted vertical padding for dropdown items
                    px: '16px', // Adjusted horizontal padding for dropdown items
                    fontSize: '0.875rem', // Adjusted font size for dropdown items (corresponds to body2)
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                    {city}
                  </MenuItem>
                ))}
              </Select>
              <Select
                value={selectedType}
                onChange={(e) => setSelectedType(e.target.value as string)}
                displayEmpty
                inputProps={{ "aria-label": "Select type" }}
                size="small"
                sx={{ width: { xs: '100%', md: 180 }, borderRadius: 1 }}
              >
                <MenuItem value="all">All Types</MenuItem>
                {memberTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>

          {/* Tabs Styling - Reimplemented with Box and Buttons */}
          <Box
            sx={{
              borderRadius: '6px', // Matches client's rounded-md
              overflow: 'hidden', // Ensures inner elements respect border radius
              mb: 3,
              bgcolor: '#F8F9FA', // Matches client's bg-muted
              p: '4px', // Matches client's p-1
              display: 'grid', // Use grid for layout
              gridTemplateColumns: 'repeat(3, 1fr)', // 3 columns, equal width
              height: '40px', // Matches client's h-10
              alignItems: 'center', // Center items vertically
              width: '100%', // Take full width
              gap: '4px', // Apply gap directly to the grid container
            }}
          >
            {/* Custom Tab Button for Members */}
            <Button
              type="button"
              role="tab"
              aria-selected={activeTab === 0}
              onClick={() => setActiveTab(0)}
              sx={{
                justifyContent: 'center',
                whiteSpace: 'nowrap',
                borderRadius: '4px', // rounded-sm
                px: '12px', // px-3
                py: '6px', // py-1.5
                fontSize: '0.875rem', // text-sm
                fontWeight: activeTab === 0 ? 'bold' : 'normal', // font-medium
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                height: '32px', // Calculated height
                display: 'flex',
                alignItems: 'center',
                gap: '8px', // gap-2
                color: activeTab === 0 ? 'black' : '#6c757d', // text-foreground vs text-muted-foreground
                backgroundColor: activeTab === 0 ? 'white' : 'transparent', // bg-background vs transparent
                boxShadow: activeTab === 0 ? '0px 1px 2px rgba(0, 0, 0, 0.1)' : 'none', // shadow-2xs
                '&:hover': {
                  backgroundColor: '#e9ecef', // Light grey on hover for inactive tabs
                  // Maintain current active state styles on hover for active tab
                  ...(activeTab === 0 && {
                    backgroundColor: 'white',
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                  }),
                },
                // Remove default button styles
                minWidth: 'unset',
                textTransform: 'none',
              }}
            >
              <UsersIcon sx={{ fontSize: '1rem' }} /> {/* h-4 w-4 */}
              Members ({members.length})
            </Button>

            {/* Custom Tab Button for Pending Requests */}
            <Button
              type="button"
              role="tab"
              aria-selected={activeTab === 1}
              onClick={() => setActiveTab(1)}
              sx={{
                justifyContent: 'center',
                whiteSpace: 'nowrap',
                borderRadius: '4px',
                px: '12px',
                py: '6px',
                fontSize: '0.875rem',
                fontWeight: activeTab === 1 ? 'bold' : 'normal',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: activeTab === 1 ? 'black' : '#6c757d',
                backgroundColor: activeTab === 1 ? 'white' : 'transparent',
                boxShadow: activeTab === 1 ? '0px 1px 2px rgba(0, 0, 0, 0.1)' : 'none',
                '&:hover': {
                  backgroundColor: '#e9ecef',
                  ...(activeTab === 1 && {
                    backgroundColor: 'white',
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                  }),
                },
                minWidth: 'unset',
                textTransform: 'none',
              }}
            >
              <ClockIcon sx={{ fontSize: '1rem' }} />
              Pending Requests ({pendingRequests.length})
            </Button>

            {/* Custom Tab Button for My Contacts */}
            <Button
              type="button"
              role="tab"
              aria-selected={activeTab === 2}
              onClick={() => setActiveTab(2)}
              sx={{
                justifyContent: 'center',
                whiteSpace: 'nowrap',
                borderRadius: '4px',
                px: '12px',
                py: '6px',
                fontSize: '0.875rem',
                fontWeight: activeTab === 2 ? 'bold' : 'normal',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                color: activeTab === 2 ? 'black' : '#6c757d',
                backgroundColor: activeTab === 2 ? 'white' : 'transparent',
                boxShadow: activeTab === 2 ? '0px 1px 2px rgba(0, 0, 0, 0.1)' : 'none',
                '&:hover': {
                  backgroundColor: '#e9ecef',
                  ...(activeTab === 2 && {
                    backgroundColor: 'white',
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                  }),
                },
                minWidth: 'unset',
                textTransform: 'none',
              }}
            >
              <UserCheckIcon sx={{ fontSize: '1rem' }} />
              My Contacts ({myContacts.length})
            </Button>
          </Box>

          <CustomTabPanel value={activeTab} index={0}>
            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 1, border: '1px solid #e0e0e0' }}>
              <Table sx={{ minWidth: 650 }} aria-label="members table">
                <TableHead>
                  <TableRow sx={{ borderBottom: '1px solid #e0e0e0' /* border-b border-muted */ }}>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' /* flex items-center */ }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedMembers.length === members.length && members.length > 0}
                              onChange={() => selectAll(members)}
                              size="small"
                              icon={
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    border: '1px solid #00194A', // match border color
                                    borderRadius: '4px', // same rounded style
                                  }}
                                />
                              }
                              checkedIcon={
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    border: '1px solid #00194A',
                                    borderRadius: '4px',
                                    backgroundColor: '#00194A', // fill color
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <CheckIcon sx={{ fontSize: 16, color: 'white' }} />
                                </Box>
                              }
                            />
                          }
                          label={<Typography variant="body2" sx={{ ml: '8px', fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* ml-2 text-sm font-medium */ }}>Select All</Typography>}
                          sx={{ m: 0 }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' /* flex items-center */ }}>
                        <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Name</Typography>
                        <ArrowUpDownIcon sx={{ ml: '4px', fontSize: '1rem' /* ml-1 h-4 w-4 */ }} />
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Address</Typography>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Phone</Typography>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Actions</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {members.length > 0 ? (
                    members.map((member) => renderMemberRow(member, "members"))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} sx={{ textAlign: 'center', py: 3 }}>
                        <Typography variant="body2" color="text.secondary">No members found.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            {selectedMembers.length > 0 && (
              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant="contained" sx={{ bgcolor: 'primary.main', '&:hover': { bgcolor: 'primary.dark' }, textTransform: 'none', borderRadius: 1 }}>
                  Invite Selected Partners
                </Button>
              </Box>
            )}
          </CustomTabPanel>

          <CustomTabPanel value={activeTab} index={1}>
            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 1, border: '1px solid #e0e0e0' }}>
              <Table sx={{ minWidth: 650 }} aria-label="pending requests table">
                <TableHead>
                  <TableRow sx={{ borderBottom: '1px solid #e0e0e0' /* border-b border-muted */ }}>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' /* flex items-center */ }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedMembers.length === pendingRequests.length && pendingRequests.length > 0}
                              onChange={() => selectAll(pendingRequests)}
                              size="small"
                              icon={
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    border: '1px solid #00194A', // match border color
                                    borderRadius: '4px', // same rounded style
                                  }}
                                />
                              }
                              checkedIcon={
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    border: '1px solid #00194A',
                                    borderRadius: '4px',
                                    backgroundColor: '#00194A', // fill color
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <CheckIcon sx={{ fontSize: 16, color: 'white' }} />
                                </Box>
                              }
                            />
                          }
                          label={<Typography variant="body2" sx={{ ml: '8px', fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* ml-2 text-sm font-medium */ }}>Select All</Typography>}
                          sx={{ m: 0 }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' /* flex items-center */ }}>
                        <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Name</Typography>
                        <ArrowUpDownIcon sx={{ ml: '4px', fontSize: '1rem' /* ml-1 h-4 w-4 */ }} />
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Address</Typography>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Phone</Typography>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Request Date</Typography>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Actions</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pendingRequests.length > 0 ? (
                    pendingRequests.map((member) => renderMemberRow(member, "pending"))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} sx={{ textAlign: 'center', py: 3 }}>
                        <Typography variant="body2" color="text.secondary">No pending requests found.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>

          <CustomTabPanel value={activeTab} index={2}>
            <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 1, border: '1px solid #e0e0e0' }}>
              <Table sx={{ minWidth: 650 }} aria-label="my contacts table">
                <TableHead>
                  <TableRow sx={{ borderBottom: '1px solid #e0e0e0' /* border-b border-muted */ }}>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' /* flex items-center */ }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedMembers.length === myContacts.length && myContacts.length > 0}
                              onChange={() => selectAll(myContacts)}
                              size="small"
                              icon={
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    border: '1px solid #00194A', // match border color
                                    borderRadius: '4px', // same rounded style
                                  }}
                                />
                              }
                              checkedIcon={
                                <Box
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    border: '1px solid #00194A',
                                    borderRadius: '4px',
                                    backgroundColor: '#00194A', // fill color
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                >
                                  <CheckIcon sx={{ fontSize: 16, color: 'white' }} />
                                </Box>
                              }
                            />
                          }
                          label={<Typography variant="body2" sx={{ ml: '8px', fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* ml-2 text-sm font-medium */ }}>Select All</Typography>}
                          sx={{ m: 0 }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Box sx={{ display: 'flex', alignItems: 'center' /* flex items-center */ }}>
                        <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Name</Typography>
                        <ArrowUpDownIcon sx={{ ml: '4px', fontSize: '1rem' /* ml-1 h-4 w-4 */ }} />
                      </Box>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Address</Typography>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Phone</Typography>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Connected Date</Typography>
                    </TableCell>
                    <TableCell sx={{ py: '12px', px: '16px', textAlign: 'left' /* py-3 px-4 text-left */ }}>
                      <Typography variant="body2" sx={{ fontSize: '0.875rem', fontWeight: 'medium', whiteSpace: 'nowrap' /* text-sm font-medium */ }}>Actions</Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {myContacts.length > 0 ? (
                    myContacts.map((member) => renderMemberRow(member, "contacts"))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} sx={{ textAlign: 'center', py: 3 }}>
                        <Typography variant="body2" color="text.secondary">No contacts found.</Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        </Paper>
      </Box>

      {/* Floating Action Button */}
      <Box sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1200 }}>
        {/* Sub-FABs container */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1.5,
            right: 0, // Align with main FAB
            transform: isFabOpen ? 'translateY(-68px)' : 'translateY(0)',
            opacity: isFabOpen ? 1 : 0,
            pointerEvents: isFabOpen ? 'auto' : 'none',
            transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            
            <Tooltip title="Invite Partner" placement="left" arrow>
            <Fab
              size="small" // Smaller FAB for sub-items
              sx={{ bgcolor: 'white', '&:hover': { bgcolor: 'grey.50' }, boxShadow: 3 }}
              onClick={() => console.log("Navigate to invite partner")} // Replaced router.push
            >
             <Link
                       to="/invite-partner"
                       style={{display: "flex", alignItems: "center"}}
                     > <UserPlusIcon sx={{ color: 'rgba(4, 119, 130, 1)', // Accent equivalent
            '&:hover': { color: 'rgba(1, 150, 164, 1)' } }} /></Link>
            </Fab>
            </Tooltip>
          </Box>
          {/* Add other sub-FABs here if needed, following the same pattern */}
        </Box>

        {/* Main FAB */}
        <Fab
          color="primary" // Use primary color from theme
          aria-label="add"
          sx={{
            width: 56, // h-14 w-14
            height: 56,
            bgcolor: 'rgba(4, 119, 130, 1)', // Accent equivalent
            '&:hover': { bgcolor: 'rgba(1, 150, 164, 1)' }, // Accent/90 equivalent
            boxShadow: 3, // shadow-lg
            position: 'relative',
            zIndex: 10,
          }}
          onClick={() => setIsFabOpen(!isFabOpen)}
        >
          {isFabOpen ? <XIcon sx={{ color: 'white' }} /> : <PlusIcon sx={{ color: 'white' }} />}
        </Fab>
      </Box>
    </Box>
  )
}

export default MyNetworkPage
